import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';
const SectionsList = lazy(() => import('../../pages/bot-flow-management/SectionsList'));
const SectionEdit = lazy(() => import('../../pages/bot-flow-management/EditSection'));
const UserDefinedSectionEdit = lazy(() => import('../../pages/bot-flow-management/Edit-User-Defined-Section'));
const BotProfile = lazy(() => import('../../pages/bot-flow-management/Bot-Profile'));
const BusinessSettings = lazy(() => import('../../pages/bot-flow-management/BusinessSettings'));
const WidgetTest = lazy(() => import('../../pages/bot-flow-management/Test-Widget'));

const ContentManagementRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/`} component={SectionsList} />
            <Route exact path={`${path}/profile`} component={BotProfile} />
            <Route exact path={`${path}/business-information`} component={BusinessSettings} />
            <Route exact path={`${path}/widget-test`} component={WidgetTest} />
            <Route exact path={`${path}/section/:sectionId`} component={SectionEdit} />
            <Route exact path={`${path}/user-defined-section/:sectionId`} component={UserDefinedSectionEdit} />
            <Route exact path={`${path}/user-defined-section/create`} component={UserDefinedSectionEdit} />
        </Switch>
    );
};

export default ContentManagementRoute;
